export default '/build/0a5db9fd.svg'